import { render, staticRenderFns } from "./PageEducatorInstitutionInactiveClassroom.vue?vue&type=template&id=d1f7637c&scoped=true&"
import script from "./PageEducatorInstitutionInactiveClassroom.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionInactiveClassroom.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionInactiveClassroom.vue?vue&type=style&index=0&id=d1f7637c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f7637c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VRow})
